// extracted by css-extract-rspack-plugin
export default {"Details":"FundraiserCard_Details__XURT5","BannerSkeleton":"FundraiserCard_BannerSkeleton__wZiRE","ProgressBarSkeleton":"FundraiserCard_ProgressBarSkeleton__7v4C4"};